<template>
  <div class="book">
    <!-- 头部搜索框开始 -->
    <TopNav
      :isTransparency="active!==3 ? true : false"
      :backgroundColor="active===2 ?'#FCB645' : '#53a2ff'"
      @handleAvatar="openTo"
      @search="$router.push({name:'SearchResult', query:{active}})"
    ></TopNav>
    <!-- 头部搜索框结束 -->
    <PersonalPopup ref="PersonalPopup" />

    <div class="section" :class="{padTop:active===3 ? true: false}">
      <div class="top">
        <template v-if="personInfo.role !== 'STUDENT'">
          <van-image v-if="active===2" class="img" fit="fill" :src="require('@/assets/images/book/img_bg_02.png')" />
          <span v-else-if="active===3" class="img" fit="fill"/>
          <van-image v-else-if="active===0" class="img" fit="fill" :src="require('@/assets/images/book/img_bg_06.png')"/>
          <van-image v-else class="img" fit="fill" :src="require('@/assets/images/book/img_bg_01.png')" />
        </template>
        <template v-else>
          <van-image v-if="active===2" class="img" fit="fill" :src="require('@/assets/images/book/img_bg_02.png')" />
          <span v-else-if="active===3" class="img" fit="fill"/>
          <van-image v-else-if="active===0" class="img" fit="fill" :src="require('@/assets/images/book/img_bg_05.png')"/>
          <van-image v-else class="img" fit="fill" :src="require('@/assets/images/book/img_bg_01.png')" />
        </template>
      </div>
      <van-tabs
        v-model="active"
        @click="clearChannelId"
        class="vanTabs"
        :class="{customActive:active===2}"
        :swipeable="true"
        :animated="true"
      >
        <van-tab
          :title="item"
          v-for="(item, index) in tabs"
          :key="index"
          :name="index * 1"
        >
          <PullRefresh v-model="isLoading" @refresh="init">
            <!-- 列表展示开始 -->
              <!-- 搜索条件展示开始 -->
              <div v-if="active!==3" class="section_content" :class="['section_content'+active]">
                <div class="left">
                  <ul class="list">
                    <li class="list_item"
                      :class="{'active':listDeatil.currentIndex===index}"
                      v-for="(item, index) in list"
                      :key="index"
                      @click="change(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="right" @click="openPop">
                  <span class="text">筛选</span>
                  <van-image class="img" fit="fill" :src="require('@/assets/images/book/icon_search_01.png')"></van-image>
                </div>
              </div>
              <!-- 搜索条件展示结束 -->
                <Empty v-if="detail.totalCount===0"></Empty>
                <van-list
                  v-else
                  v-model="detail.loading"
                  :finished="detail.finished"
                  @load="getDetail"
                  finished-text="没有更多了"
                  class="box"
                  :offset="100"
                >
                  <template v-if="active!==3">
                    <div class="box_item"
                      v-for="(item, index) in detail.list"
                      :key="index"
                      @click="jumpTo(item)"
                    >
                      <div class="box_title">
                        <van-image class="img" :src="item.cover"></van-image>
                        <div class="text"  :style="{backgroundColor:active===2?'rgba(0,0,0)':'rgba(0,0,0,.5)'}">
                          <span v-if="active!==2">{{ item.learnCount }}人已学</span>
                          <span v-else>
                            <van-image class="icon" :src="require('@/assets/images/book/icon_03.png')"></van-image>
                            {{ item.views }}
                          </span>
                        </div>

                        <div class="hot" v-if="item.isRecommend===1">
                          <van-image class="img_tap" :src="require('@/assets/images/book/icon_01.png')"></van-image>
                        </div>
                      </div>
                      <div class="box_content">
                        <div class="title">{{ item.name || item.title }}</div>
                        <div class="text_01">{{ item.organizationName || item.sourceName }}</div>
                        <div class="text_02" v-if="!item.free">{{ item.price }}</div>
                        <div class="text_02" v-else>免费</div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <!-- 书架部门 -->
                    <div class="section_content section_content3">
                      <div class="box3">
                        <div class="box_item" @click="$router.push({name:'BookshelfDetail', query:{id:item.id}})" v-for="item in detail.list" :key="item.id">
                          <div class="releative">
                            <van-image class="img" fit="cover" :src="item.image"></van-image>
                            <div class="info">
                              <div class="text"><i class="icon_book"></i>{{ item.booksNum }}本</div>
                            </div>
                          </div>
                          <div class="content"></div>
                          <div class="title">{{ item.name }}</div>
                        </div>
                      </div>
                    </div>


                  </template>
                </van-list>
          </PullRefresh>
        </van-tab>
      </van-tabs>
    </div>

    <van-popup
      v-model="popupShow"
      round
      position="right"
      :style="{ height: '100vh',width: '80%' }"
      class="popup"
    >
      <!-- 课程等多项列表的选择开始 -->
      <div class="container">
        <!-- 类型列表 -->
        <ListBook
          :detail="popup.channels"
          title="类型"
          @itemClick="itemClick($event,'channelId')"
          :active="params.channelId"
          :popupShow="popupShow"
          :currentActive="active"
        ></ListBook>
        <!-- 类型列表 -->

        <!-- 学段列表 -->
        <ListBook
          :detail="popup.periods"
          title="学段"
          @itemClick="itemClick($event,'periodId')"
          :active="params.periodId"
          :popupShow="popupShow"
          :currentActive="active"
        ></ListBook>
        <!-- 学段列表 -->

        <!-- 学科列表 -->
        <ListBook
          :detail="popup.subjects"
          title="学科"
          @itemClick="itemClick($event,'subjectId')"
          :active="params.subjectId"
          :popupShow="popupShow"
          :currentActive="active"
        ></ListBook>
        <!-- 学科列表 -->

        <!-- 版本列表 -->
        <ListBook
          :detail="popup.versions || popup.editions"
          title="版本"
          @itemClick="itemClick($event,'versionId')"
          :active="params.versionId"
          :popupShow="popupShow"
          :currentActive="active"
        ></ListBook>
        <!-- 版本列表 -->

        <!-- 年级列表 -->
        <ListBook
          :detail="popup.stages"
          title="年级"
          @itemClick="itemClick($event,'stageId')"
          :active="params.stageId"
          :popupShow="popupShow"
          :currentActive="active"
        ></ListBook>
        <!-- 年级列表 -->
      </div>
      <!-- 课程等多项列表的选择结束 -->

      <!-- 底部确定按钮开始 -->
      <div class="fixed">
        <Button class="btn" :class="'btn'+active" @click="submit">
          确定
        </Button>
      </div>
      <!-- 底部确定按钮结束 -->

    </van-popup>
  </div>
</template>

<script>
import { TopNav, Empty } from '@/components';
import ListBook from './components/ListBook.vue';
import { Button, PullRefresh } from 'vant';
import PersonalPopup from '@/views/personal/PersonalPopup';
import { mapGetters } from 'vuex';

export default {
  name: 'Book',

  components: {
    TopNav,
    Empty,
    ListBook,
    Button,
    PullRefresh,
    PersonalPopup
  },

  data () {
    return {
      type: 0, // 查询类型
      active: 0, // 当前选中项
      currentChannelId: 0, // 当前类型选中项
      tabs: {
        0: '粤教培训',
        // 1: '优秀课例',
        2: '教学资源',
        3: '书架'
      },
      list: ['综合培训', '最新', '人气'],
      listDeatil: {
        currentIndex: 0
      },
      name: {
        0: 'course', // 粤教培训
        1: 'lesson', // 优秀课例
        2: 'resource', // 教学资源
        3: 'bookshelf' // 书架
      },
      isLoading: false,
      detail: {
        finished: false,
        loading: false,
        pageNo: 1,
        list: [],
        totalCount: '',
        pageSize: 10
      },

      popup: {}, // 弹层数据
      popupShow: false, // 弹层显影

      cacheParams: {
        channelId: 0, // 类型
        periodId: 0, // 学段
        subjectId: 0, // 学科
        versionId: 0, // 版本
        stageId: 0 // 年级
      },
      params: {
        channelId: 0, // 类型
        periodId: 0, // 学段
        subjectId: 0, // 学科
        versionId: 0, // 版本
        stageId: 0, // 年级
        orderBy: 0 // 排序
      },
      // span: 3, // 每行列数，移动端3列，PC端6列
    };
  },

  computed: {
    ...mapGetters(['personInfo'])
  },
  mounted () {
    // this.span = this.isMobile() ? 3 : 6;
    // console.log('传递过来的参数', this.$route.query);
    this.currentChannelId = this.$route.query.channelId * 1 || 0; // 转为数字类型
    // 通过跳转获取active值
    if (this.personInfo.role === 'STUDENT') {
      this.tabs[0] = '在线学习';
      delete this.tabs[1];
    }
    this.active = this.$route.query.active * 1 || 0; // 一定要转为数字类型 ！！！！！！！
    if (this.active !== 3) {
      this.getCourseDetail();
    }
  },

  watch: {
    active: {
      handler (newValue) {
        // 将选择与排序初始化
        this.listDeatil.currentIndex = 0;
        // this.params.orderBy = this.listDeatil.currentIndex;
        console.log('新的++++', newValue);
        if (newValue === 0 || newValue === 1) {
          // 粤教培训和优秀课例
          this.params = {
            // channelId: 0, // 类型
            channelId: this.currentChannelId, // 类型
            periodId: 0, // 学段
            subjectId: 0, // 学科
            versionId: 0, // 版本
            stageId: 0, // 年级
            orderBy: 0 // 排序
          };
          this.cacheParams = {
            // channelId: 0, // 类型
            channelId: this.currentChannelId, // 类型
            periodId: 0, // 学段
            subjectId: 0, // 学科
            versionId: 0, // 版本
            stageId: 0 // 年级
          };
        } else if (newValue === 2) {
          // 查询教学资源
          // 获取
          this.params = {
            // channelId: 0, // 类型
            channelId: this.currentChannelId, // 类型
            periodId: 0, // 学段
            subjectId: 0, // 学科
            editionId: 0, // 版本
            stageId: 0, // 年级
            orderType: 0 // 排序
          };
          this.cacheParams = {
            // channelId: 0, // 类型
            channelId: this.currentChannelId, // 类型
            periodId: 0, // 学段
            subjectId: 0, // 学科
            editionId: 0, // 版本
            stageId: 0 // 年级
          };
        }
        this.$router.push({ name: 'Book', query: { active: newValue, channelId: this.currentChannelId } });
        this.init();
      }
    }
  },

  methods: {
    // 判断设备是否为移动端
    // isMobile() {
    //   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //   return flag;
    // },
    /* 初始化数据 */
    init () {
      const { active } = this;
      this.detail = {
        finished: false,
        loading: true,
        pageNo: 1,
        list: [],
        totalCount: '',
        pageSize: 10
      };

      if (active !== 3) {
        this.getCourseDetail();
      }
      this.getDetail();
      this.isLoading = false;
    },

    openTo () {
      if (this.personInfo.role !== 'STUDENT') {
        this.handleAvatar();
      } else {
        this.$router.push({ name: 'Personal' });
      }
    },

    handleAvatar () {
      this.$refs.PersonalPopup.show();
    },

    /* 获取弹层列表数据 */
    getCourseDetail () {
      // course/channel/list 粤教培训
      // lesson/channel/list 优秀课例
      // resource/channel //教学资源
      const { $http, name, active } = this;
      let isList = active === 2 ? '/channel' : '/channel/list';
      $http.get(`${name[active] + isList}`, {
      }).then((res) => {
        this.popup = res.data || {};
        // 对获取的数据每一项都添加全部按钮 并且id为0
        for (let item in this.popup) {
          this.popup[item].unshift({ id: 0, name: '全部' });
        }

      });
    },

    /* 获取课程数据列表 */
    getDetail () {
      // course/list 粤教培训
      // lesson/list 优秀课例
      // resource/list 课程资源


      let { $http, name, detail, params, active } = this;
      console.log('params+++', params);
      let paramsObj = {};
      let paramsShare = {};
      switch (active) {
        case 0:
          paramsObj = { ...params, pageNo: detail.pageNo };
          paramsShare = {
            // title: '粤教培训 广东教育出版社',
            title: '广东教育出版社 | 南方E课堂',
            desc: '这里有您需要的在线课程，快来看看吧！'
          };
          break;
        case 1:
          paramsObj = { ...params, pageNo: detail.pageNo };
          paramsShare = {
            // title: '优秀课例 广东教育出版社',
            title: '广东教育出版社 | 南方E课堂',
            desc: '这里有您需要的优秀课例，快来看看吧！'
          };
          break;
        case 2:
          paramsObj = { ...params, pageNo: detail.pageNo };
          paramsShare = {
            // title: '教学资源 广东教育出版社',
            title: '广东教育出版社 | 南方E课堂',
            desc: '这里有您需要的教学资源，快来看看吧！'
          };
          break;
        case 3:
          paramsObj = { key: '', pageNo: detail.pageNo, pageSize: detail.pageSize };
          paramsShare = {
            // title: '广东教育出版社',
            title: '广东教育出版社 | 南方E课堂',
            desc: '在这里成为不被定义的教育者。我们在这里，你在哪？'
          };
          break;
      }
      $http.get(`${name[active]}/list`, {
        params: paramsObj,
        showLoading: true
      }).then((res) => {
        console.log('getDetail', res);
        const { isHasNext, nextPage, result, totalCount } = res.data.page || res.data || {};
        detail.finished = !isHasNext;
        detail.list.push(...result);
        detail.pageNo = nextPage;
        detail.loading = false;
        detail.totalCount = totalCount;
        this.detail = detail;
        this.$wxShare({ ...paramsShare, link: location.href });
      });

    },

    // /* tab栏切换 */
    // tabClick (name) {
    //   this.active = name;
    //   // 将选择与排序初始化
    //   this.listDeatil.currentIndex = 0;
    //   // this.params.orderBy = this.listDeatil.currentIndex;
    //   this.params = {
    //     channelId: 0, // 类型
    //     periodId: 0, // 学段
    //     subjectId: 0, // 学科
    //     versionId: 0, // 版本
    //     stageId: 0, // 年级
    //     orderBy: 0 // 排序
    //   };

    //   this.init();
    // },

    /* 列表项跳转页面 */
    jumpTo (item) {
      const { $router, active } = this;
      if (active === 0 || active === 1) {
        $router.push({ name: 'BookClassDetail', query: { id: item.id, active } });
      } else if (active === 2) {
        $router.push({ name: 'BookDetail', query: { id: item.id } });
      }
    },

    /* 综合,最新 ,人气 进行筛选 */
    change (index) {
      let { listDeatil } = this;
      listDeatil.currentIndex = index;
      if (this.active === 0 || this.active === 1) {
        this.params.orderBy = listDeatil.currentIndex;
      } else {
        this.params.orderType = listDeatil.currentIndex;
      }
      this.init();
    },

    /* 获取筛选课程后获取的所有id值 */
    itemClick (id, key) {
      this.cacheParams[key] = id;
    },

    /* 提交按钮 */
    submit () {
      if (this.active === 0 || this.active === 1) {
        this.params = { ...JSON.parse(JSON.stringify(this.cacheParams)), orderBy: this.params.orderBy };
      } else {
        this.params = { ...JSON.parse(JSON.stringify(this.cacheParams)), orderType: this.params.orderType };
      }
      this.init();
      this.popupShow = false;
    },

    /* 打开弹层 */
    openPop () {
      this.popupShow = true;
    },
    clearChannelId () {
      // 初始化channelId
      this.currentChannelId = 0;
    }

  }

};
</script>

<style lang="less" scoped>
  .book{
    min-height: calc(100vh - 96px);
    background-color: #F7F8FA;
    .section{
      &.padTop{
        padding-top: 114px;
      }
      .top{
        .img{
          width: 100%;
          height: 400px;
        }
      }
      .customActive {
        /deep/.van-tabs__wrap{
          .van-tab--active{
            color: #FCB645;
            span{
              font-weight: bold;
            }
          }
          .van-tabs__line{
            background: url('~@/assets/images/book/icon_02.png') no-repeat center center;
            background-size: contain;
          }
        }

      }
      .section_content{
        display: flex;
        align-items: center;
        font-size: 28px;
        line-height: 44px;
        color: #333444;
        padding: 32px 28px;
        justify-content: space-between;
        .left{
          .list{
            display: flex;
            .list_item{
              margin-right: 40px;
              &:last-child{
                margin-right: 0;
              }
            }
          }
        }
        .right{
          display: flex;
          align-items: center;
          .img{
            width: 40px;
            height: 40px;
          }
        }
        &,
        .section_content0,
        .section_content1{
          .active{
            color: #5FA9FF;
          }
        }
        &.section_content2{
          .active{
            color: #FCB645;
          }
        }
        &.section_content3{
          padding: 0;
          .box3{
            display: flex;
            flex-wrap: wrap;
            align-items: start;
            .box_item{
              position: relative;
              margin-right: 46px;
              margin-top: 40px;
              width: 188px;
              display: flex;
              flex-direction: column;
              &:nth-child(-n+3){
                margin-top: 0;
              }
              &:nth-child(3n){
                margin-right: 0px;
              }
              .releative{
                position: relative;
                .img{
                  z-index: 2;
                  width: 100%;
                  height: 218px;
                  border-radius: 16px;
                  overflow: hidden;
                }
                .info{
                  position: absolute;
                  z-index: 11;
                  bottom: 0;
                  display: flex;
                  right: 0;
                  flex-direction: column;
                  justify-content: center;
                  &::before {
                    display: block;
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(255, 255, 255, .1);
                    backdrop-filter: blur(60px);
                  }
                  .text{
                    font-size: 16px;
                    color: #FFFFFF;
                    display: flex;
                    position: relative;
                    align-items: center;
                    padding: 0 10px;
                    border-radius: 8px 0px 8px 0px;
                    .icon_book{
                      width: 19px;
                      height: 18px;
                      vertical-align: middle;
                      background-image: url("~@/assets/images/icon_book_03.png");
                      background-size: contain;
                      display: inline-block;
                      margin-right: 6px;
                      background-repeat: no-repeat;
                    }
                  }
                }
              }
              .content{
                position: absolute;
                width: 98%;
                height: 79%;
                background: #000000;
                opacity: 0.2;
                border-radius: 0.10667rem;
                z-index: 1;
                left: 0;
                right: 0;
                margin: 0 auto;
                &::after{
                  content:"";
                  position: absolute;
                  display: block;
                  width: 90%;
                  height: 102%;
                  background: #000000;
                  opacity: 0.65;
                  border-radius: 0.10667rem;
                  z-index: 1;
                  left: 0;
                  right: 0;
                  margin: 0 auto;
                }
              }
              .title{
                margin-top: 20px;
                font-size: 22px;
                color: #333333;
                text-align: center;
                display:block;
                word-break:keep-all;       /* 不换行 */
                white-space:nowrap;        /* 不换行 */
                overflow:hidden;           /* 内容超出宽度时隐藏超出部分的内容 */
                text-overflow:ellipsis;    /*溢出时显示省略标记...；需与overflow:hidden;一起使用*/
              }
            }
          }
        }
      }
      .box{
        padding: 22px 28px;
        display: flex;
        flex-wrap: wrap;
        .box_item{
          background: rgba(0, 0, 0, 0);
          border-radius: 8px 8px 0px 0px;
          // overflow: hidden;
          flex-shrink: 1;
          margin-right: 22px;
          margin-top: 20px;
          width: 336px;
          .text-overflow();
          &:nth-child(2n){
            margin-right: 0px;
          }
          &:nth-child(-n+2){
            margin-top: 0px;
          }
          .box_title{
            position: relative;
            height: 224px;
            .img{
              width: 336px;
              border-radius: 8px 8px 0px 0px;
              height: 224px;
              overflow: hidden;
              display: inline-block;
            }
            .text{
              position: absolute;
              font-size: 20px;
              color: #FFFFFF;
              background: rgba(0, 0, 0, .5);
              border-radius: 8px 8px 0px 0px;
              padding: 6px 12px;
              right: 0;
              bottom: 0;
              span{
                display: flex;
                align-items: center;
                .icon{
                  width: 20px;
                  height: 20px;
                }
              }
            }
            .hot{
              position: absolute;
              left: 0;
              top: -8px;
              .img_tap{
                width: 86px;
                height: 48px;
              }
            }
          }
          .box_content{
            padding: 18px 20px;
            background-color: #fff;
            border-radius: 0px 0px 8px 8px;
            .title{
              font-size: 26px;
              font-weight: bold;
              color: #333444;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              height: 36px;
            }
            .text_01{
              font-size: 22px;
              color: #999AAA;
              margin-bottom: 12px;
              height: 32px;
            }
            .text_02{
              font-size: 24px;
              font-weight: bold;
              color: #FF485D;
              height: 34px;
            }
          }
        }
        /deep/.van-list__finished-text{
          display: block;
          width: 100%;
        }
        /deep/.van-list__loading{
          display: block;
          width: 100%;
        }
      }
    }
    .popup{
      padding: 40px 40px 20px;
      display: flex;
      flex-direction: column;
      .container{
        flex:1;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
      }
      .fixed{
        width: 100%;
        height: 90px;
        background-color: #fff;
        line-height: 90px;
        padding-top:10px ;
        .btn{
          width: 470px;
          height: 80px;
          background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
          box-shadow: 0px 6px 12px rgba(79, 157, 255, 0.2);
          border-radius: 40px;
          font-size: 26px;
          font-weight: 500;
          line-height: 80px;
          color: #FFFFFF;
          display: block;
          text-align: center;
          margin: 0 auto;
          &.btn2{
            background: linear-gradient(90deg, #FCB645 0%, #FC9D1B 100%);
          }
        }
      }

    }
  }
</style>